import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { Observable } from 'rxjs';
import { TenantUserList } from '../_objects/user';
import { HttpService } from './http.service';
import { RtbAuthService } from '../auth/rtb-auth.service';


@Injectable()
export class TenantUserService extends HttpService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router,
    private rtbAuthService: RtbAuthService,
  ) {
    super(rtbAuthService);
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }

  public getUsers(): Observable<TenantUserList[]> {
    const endpoint = '/api/users';
    return this.http.get<TenantUserList[]>(endpoint);
  }
}
